import { createLocaleManager } from '@previo/core'

const idLocaleManager = createLocaleManager()

export { idLocaleManager }
